import './i18n';

import {
  createBrowserRouter, createRoutesFromElements, generatePath,
  Navigate, Route, RouterProvider,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ReactComponent as SendIcon } from 'assets/icons/send-rounded.svg';
import { ReactComponent as ToastErrorIcon } from 'assets/icons/toast-error.svg';
import FullScreen from 'components/FullScreen/FullScreen';
import { AppRoutes } from 'constants/AppRoutes';
import AuthLayout from 'layout/AuthLayout/AuthLayout';
import ClientProfileLayout from 'layout/ClientProfileLayout/ClientProfileLayout';
import CreateClientLayout from 'layout/CreateClientLayout/CreateClientLayout';
import MaterialAssessmentImportLayout from 'layout/MaterialAssessmentImportLayout/MaterialAssessmentImportLayout';
import MaterialAssessmentLayout from 'layout/MaterialAssessmentLayout/MaterialAssessmentLayout';
import PageProtected from 'layout/Page/PageProtected';
import ProfileLayout from 'layout/ProfileLayout/ProfileLayout';
import AuthenticationType from 'pages/AuthPages/AuthenticationType/AuthenticationType';
import Login from 'pages/AuthPages/Login/Login';
import NewPassword from 'pages/AuthPages/NewPassword/NewPassword';
import RecoverPassword from 'pages/AuthPages/RecoverPassword/RecoverPassword';
import RecoverPasswordSuccess from 'pages/AuthPages/RecoverPasswordSuccess/RecoverPasswordSuccess';
import VerificationCode from 'pages/AuthPages/VerificationCode/VerificationCode';
import VerificationSms from 'pages/AuthPages/VerificationSms/VerificationSms';
import VerificationSmsSetup from 'pages/AuthPages/VerificationSmsSetup/VerificationSmsSetup';
import Settings from 'pages/CompanyAdminPages/Settings/Settings';
import UserManagement from 'pages/CompanyAdminPages/UserManagement/UserManagement';
import ValueChainMap from 'pages/CompanyAdminPages/ValueChainMap/ValueChainMap';
import MAIroScoring from 'pages/MaterialAssessmentPages/MAIroScoring/MAIroScoring';
import MARespondentSurveys from 'pages/MaterialAssessmentPages/MARespondentSurveys/MARespondentSurveys';
import MaterialAssessmentIROIndetificator from 'pages/MaterialAssessmentPages/MaterialAssessmentIROIndetificator/MaterialAssessmentIROIndetificator';
import MaterialityAssessmentStakeholder from 'pages/MaterialAssessmentPages/MaterialAssessmentStakeholder/MaterialAssessmentStakeholder';
import MaterialityAssessmentTopicRefinement from 'pages/MaterialAssessmentPages/MaterialAssessmentTopicRefinement/MaterialityAssessmentTopicRefinement';
import MaterialityAssessment from 'pages/MaterialAssessmentPages/MaterialityAssessment/MaterialityAssessment';
import MaterialityAssessmentBoard from 'pages/MaterialAssessmentPages/MaterialityAssessmentBoard/MaterialityAssessmentBoard';
import MaterialityAssessmentCommunities from 'pages/MaterialAssessmentPages/MaterialityAssessmentCommunities/MaterialityAssessmentCommunities';
import MaterialityAssessmentCustomer from 'pages/MaterialAssessmentPages/MaterialityAssessmentCustomer/MaterialityAssessmentCustomer';
import MaterialityAssessmentEmployees from 'pages/MaterialAssessmentPages/MaterialityAssessmentEmployees/MaterialityAssessmentEmployees';
import MaterialityAssessmentInitial from 'pages/MaterialAssessmentPages/MaterialityAssessmentInitial/MaterialityAssessmentInitial';
import MaterialityAssessmentInvestor from 'pages/MaterialAssessmentPages/MaterialityAssessmentInvestor/MaterialityAssessmentInvestor';
import MaterialityAssessmentMedia from 'pages/MaterialAssessmentPages/MaterialityAssessmentMedia/MaterialityAssessmentMedia';
import MaterialityAssessmentNGO from 'pages/MaterialAssessmentPages/MaterialityAssessmentNOGs/MaterialityAssessmentNGO';
import MaterialityAssessmentSupplier from 'pages/MaterialAssessmentPages/MaterialityAssessmentSupplier/MaterialityAssessmentSupplier';
import MaterialityConfigAnalysis from 'pages/MaterialAssessmentPages/MaterialityConfigAnalysis/MaterialityConfigAnalysis';
import MaterialityConfigCompetitor from 'pages/MaterialAssessmentPages/MaterialityConfigCompetitor/MaterialityConfigCompetitor';
import MaterialityConfigDisclosure from 'pages/MaterialAssessmentPages/MaterialityConfigDisclosure/MaterialityConfigInvestorsDisclosure';
import MaterialityConfigGeographic from 'pages/MaterialAssessmentPages/MaterialityConfigGeographic/MaterialityConfigGeographic';
import MaterialityConfigIndustry from 'pages/MaterialAssessmentPages/MaterialityConfigIndustry/MaterialityConfigIndustry';
import MaterialityConfigInvestorsCustomersEvidence from 'pages/MaterialAssessmentPages/MaterialityConfigInvestorsCustomersEvidence/MaterialityConfigInvestorsCustomersEvidence';
import MATopicRefinement from 'pages/MaterialAssessmentPages/MATopicRefinement/MATopicRefinement';
import AgentsManagement from 'pages/SuperAdminPages/AgentsManagement/AgentsManagement';
import Clients from 'pages/SuperAdminPages/Clients/Clients';
import CompanyAdmin from 'pages/SuperAdminPages/CompanyAdmin/CompanyAdmin';
import CompanyInfo from 'pages/SuperAdminPages/CompanyInfo/CompanyInfo';
import CompanyProfile from 'pages/SuperAdminPages/CompanyProfile/CompanyProfile';
import CompanyUsers from 'pages/SuperAdminPages/CompanyUsers/CompanyUsers';
import ModuleManagement from 'pages/SuperAdminPages/ModuleManagement/ModuleManagement';
import Multilingual from 'pages/SuperAdminPages/Multilingual/Multilingual';
import SectorSpecific from 'pages/SuperAdminPages/SectorSpecific/SectorSpecific';
import Security from 'pages/SuperAdminPages/Security/Security';
import SettingWeighting from 'pages/SuperAdminPages/SettingWeighting/SettingWeighting';
import Standards from 'pages/SuperAdminPages/Standards/Standards';
import StandardsIRO from 'pages/SuperAdminPages/StandardsIRO/StandardIROPage';
import MarketingOps from 'pages/SuperAdminPages/TargetedMarketing/MarketingOps';
import MarketingOpsFinding from 'pages/SuperAdminPages/TargetedMarketing/MarketingOpsFinding';
import WatchTowerCompany from 'pages/SuperAdminPages/TargetedMarketing/WatchTowerCompany';
import WatchTowerImport from 'pages/SuperAdminPages/TargetedMarketing/WatchTowerImport';
import WatchTowerRegistry from 'pages/SuperAdminPages/TargetedMarketing/WatchTowerRegistry';
import WatchTowerRuns from 'pages/SuperAdminPages/TargetedMarketing/WatchTowerRuns';
import WatchTowerSchedules from 'pages/SuperAdminPages/TargetedMarketing/WatchTowerSchedules';
import WatchTowerTopic from 'pages/SuperAdminPages/TargetedMarketing/WatchTowerTopic';
import WatchTowerTopics from 'pages/SuperAdminPages/TargetedMarketing/WatchTowerTopics';
import UIConfiguration from 'pages/SuperAdminPages/UICofiguration/UICofiguration';
import UserSecurity from 'pages/SuperAdminPages/UserSecurity/UserSecurity';
import LaunchpadHub from 'pages/UserPages/LaunchpadHub/LaunchpadHub';
import PersonalInfo from 'pages/UserPages/PersonalInfo/PersonalInfo';
import Profile from 'pages/UserPages/Profile/Profile';
import ProfileSecurity from 'pages/UserPages/Profile/Security/Security';
import ProfilePassword from 'pages/UserPages/ProfilePassword/ProfilePassword';
import ReleaseHistory from 'pages/UserPages/ReleaseHistory/ReleaseHistory';
import TaskInfo from 'pages/UserPages/TaskInfo/TaskInfo';
import TaskManagement from 'pages/UserPages/TaskManagement/TaskManagement';

import { NEW_CLIENT_ID } from './constants/general';
import useFullScreenHandle from './hooks/useFullScreenHandle';
import DataSetsLayout from './layout/DataSetsLayout/DataSetsLayout';
import SettingsLayout from './layout/SettingsLayout/SettingsLayout';
import UserManagementLayout from './layout/UserManagementLayout/UserManagementLayout';
import AuthenticationSetup from './pages/AuthPages/AuthenticationSetup/AuthenticationSetup';
import DeactivatedUser from './pages/AuthPages/DeactivatedUser/DeactivatedUser';
import CompanyMap from './pages/CompanyAdminPages/CompanyMap/CompanyMap';
import CreateNewUser from './pages/CompanyAdminPages/CreateNewUser/CreateNewUser';
import Permissions from './pages/CompanyAdminPages/Permissions/Permissions';
import UserInfo from './pages/CompanyAdminPages/UserInfo/UserInfo';
import MaterialAssessmentInsightsDashboard
  from './pages/MaterialAssessmentPages/MaterialAssessmentInsightsDashboard/MaterialAssessmentInsightsDashboard';
import MAIROQuestion from './pages/MaterialAssessmentPages/MaterialAssessmentIRO/MAIROQuestion';
import MaterialityAssessmentSurvey from './pages/MaterialAssessmentPages/MaterialAssessmentSurvey/MaterialityAssessmentSurvey';
import MaterialityAssessmentSurveyAnswer from './pages/MaterialAssessmentPages/MaterialAssessmentSurveyAnswer/MASurveyAnswer';
import CreateSurvey
  from './pages/MaterialAssessmentPages/MaterialAssessmentSurveyCreation/components/CreateSurvey/CreateSurvey';
import MaterialityAssessmentSurveyCreation
  from './pages/MaterialAssessmentPages/MaterialAssessmentSurveyCreation/MaterialityAssessmentSurveyCreation';
import MaterialityAssessmentInterview
  from './pages/MaterialAssessmentPages/MaterialAssessmentSurveyInterview/MaterialityAssessmentInterview';
import MaterialAssessmentRoundTables
  from './pages/MaterialAssessmentPages/MaterialAssessmentSurveyRoundtables/MaterialAssessmentRoundTables';
import BaseMultilingual from './pages/SuperAdminPages/BaseMultilingual/BaseMultilingual';
import CreateCustomer from './pages/UserPages/CreateCustomer/CreateCustomer';
import CreateOwnOperations from './pages/UserPages/CreateOwnOperations/CreateOwnOperations';
import CreateProduct from './pages/UserPages/CreateProduct/CreateProduct';
import CreateProfitCentre from './pages/UserPages/CreateProfitCentre/CreateProfitCentre';
import CreateSupplier from './pages/UserPages/CreateSupplier/CreateSupplier';
import Customers from './pages/UserPages/Customers/Customers';
import OwnOperations from './pages/UserPages/OwnOperations/OwnOperations';
import Products from './pages/UserPages/Products/Products';
import ProfileLanguage from './pages/UserPages/ProfileLanguage/ProfileLanguage';
import ProfitCentres from './pages/UserPages/ProfitCentres/ProfitCentres';
import Suppliers from './pages/UserPages/Suppliers/Suppliers';
import AppWrapper from './AppWrapper';

import type { ReactElement } from 'react';

import './styles/global.scss';

function App(): ReactElement {
  const fullScreenHandle = useFullScreenHandle();

  const toastIcons = ({ type }: { type: string }) => {
    if (type === 'success') { return <SendIcon />; }
    if (type === 'error') { return <ToastErrorIcon />; }
    return undefined;
  };

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<AppWrapper />}>
        <Route element={<AuthLayout />} path={AppRoutes.login}>
          <Route path={AppRoutes.login} element={<Login />} />
          <Route path={AppRoutes.authenticationType} element={<AuthenticationType />} />
          <Route path={AppRoutes.authenticationSetup} element={<AuthenticationSetup />} />
          <Route path={AppRoutes.verificationSmsSetup} element={<VerificationSmsSetup />} />

          <Route path={AppRoutes.verificationSms} element={<VerificationSms />} />
          <Route path={AppRoutes.verificationCode} element={<VerificationCode />} />
          <Route path={AppRoutes.recoverPassword} element={<RecoverPassword />} />
          <Route path={AppRoutes.recoverPasswordSuccess} element={<RecoverPasswordSuccess />} />
          <Route path={AppRoutes.newPassword} element={<NewPassword />} />
          <Route path={AppRoutes.recoverPasswordConfirm} element={<NewPassword />} />
          <Route path={AppRoutes.deactivated} element={<DeactivatedUser />} />
        </Route>
        <Route
          path={AppRoutes.materialityAssessmentSurveyAnswer}
          element={<MaterialityAssessmentSurveyAnswer />}
        />
        <Route
          path={AppRoutes.materialityAssessmentIROQuestions}
          element={<MAIROQuestion />}
        />
        <Route path={AppRoutes.home} element={<PageProtected redirectUri={AppRoutes.login} />}>
          <Route path={AppRoutes.launchpad}>
            <Route path={AppRoutes.launchpad} element={<LaunchpadHub />} />
            <Route path={AppRoutes.releaseHistory} element={<ReleaseHistory />} />

            <Route path={AppRoutes.launchpadSettings}>
              <Route path={AppRoutes.launchpadSettings} element={<Settings />} />
              <Route
                path={AppRoutes.userManagement}
                element={<UserManagementLayout />}
              >

                <Route
                  path={AppRoutes.userManagement}
                  element={<UserManagement />}
                  handle={{ skipBreadcrumbs: true }}
                />

                <Route path={AppRoutes.createNewUser} element={<CreateNewUser />} />
                <Route path={AppRoutes.userInfo}>
                  <Route path={AppRoutes.userInfo} handle={{ skipBreadcrumbs: true }} element={<UserInfo />} />
                  <Route path={AppRoutes.editUserInfo} element={<CreateNewUser />} />
                  <Route path={AppRoutes.editUserPermissions} element={<Permissions />} />
                  <Route path={AppRoutes.createUserPermissions} element={<Permissions isCreateFlow />} />
                </Route>
              </Route>
              <Route
                element={<SettingsLayout />}
                handle={{ skipBreadcrumbs: true }}
              >
                <Route path={AppRoutes.companyUiConfiguration} element={<UIConfiguration />} />
              </Route>
              <Route
                element={<DataSetsLayout />}
                handle={{ skipBreadcrumbs: true }}
              >
                <Route path={AppRoutes.balanceSheetAssets} element={<OwnOperations />} />
                <Route path={AppRoutes.suppliers} element={<Suppliers />} />
                <Route path={AppRoutes.customers} element={<Customers />} />
                <Route path={AppRoutes.products} element={<Products />} />
                <Route path={AppRoutes.profitCentres} element={<ProfitCentres />} />
                <Route path={AppRoutes.profitCentres}>
                  <Route path={AppRoutes.profitCentresCreate} element={<CreateProfitCentre />} />
                  <Route path={AppRoutes.profitCentresEdit} element={<CreateProfitCentre />} />
                </Route>
                <Route path={AppRoutes.balanceSheetAssets}>
                  <Route path={AppRoutes.balanceSheetAssetsCreate} element={<CreateOwnOperations />} />
                  <Route path={AppRoutes.balanceSheetAssetsEdit} element={<CreateOwnOperations />} />
                </Route>
                <Route path={AppRoutes.suppliers}>
                  <Route path={AppRoutes.supplierCreate} element={<CreateSupplier />} />
                  <Route path={AppRoutes.supplierEdit} element={<CreateSupplier />} />
                </Route>
                <Route path={AppRoutes.products}>
                  <Route path={AppRoutes.productsCreate} element={<CreateProduct />} />
                  <Route path={AppRoutes.productsEdit} element={<CreateProduct />} />
                </Route>
                <Route path={AppRoutes.customers}>
                  <Route path={AppRoutes.customerCreate} element={<CreateCustomer />} />
                  <Route path={AppRoutes.customerEdit} element={<CreateCustomer />} />
                </Route>
              </Route>
            </Route>
          </Route>

          <Route path={AppRoutes.launchpadHub} element={<LaunchpadHub />} />

          <Route path={AppRoutes.settingWeighting} element={<SettingWeighting />} />

          <Route element={<ProfileLayout />} path={AppRoutes.profile}>
            <Route path={AppRoutes.profile} element={<Profile />} />
            <Route path={AppRoutes.personalInfo} element={<PersonalInfo />} />
            <Route path={AppRoutes.profilePassword} element={<ProfilePassword />} />
            <Route path={AppRoutes.profileSecurity} element={<ProfileSecurity />} />
            <Route path={AppRoutes.profileLanguage} element={<ProfileLanguage />} />
          </Route>

          <Route path={AppRoutes.clients}>
            <Route index path={AppRoutes.clients} element={<Clients />} />

            <Route element={<ClientProfileLayout />} handle={{ skipBreadcrumbs: true }}>
              <Route path={AppRoutes.clientProfile}>
                <Route path={AppRoutes.clientProfile} element={<CompanyProfile />} handle={{ skipBreadcrumbs: true }} />
                <Route path={AppRoutes.clientUsers}>
                  <Route path={AppRoutes.clientUsers} element={<CompanyUsers />} handle={{ skipBreadcrumbs: true }} />
                  <Route path={AppRoutes.clientUsersSecurity}>
                    <Route
                      path={AppRoutes.clientUsersSecurity}
                      element={<UserSecurity />}
                      handle={{ skipBreadcrumbs: true }}
                    />
                  </Route>
                </Route>
              </Route>
            </Route>

            <Route element={<CreateClientLayout />} path={AppRoutes.clientsCreate}>
              <Route
                index
                element={<Navigate to={generatePath(AppRoutes.companyInfo, { clientId: NEW_CLIENT_ID })} />}
              />
              <Route path={AppRoutes.companyInfo} element={<CompanyInfo />} />
              <Route path={AppRoutes.multiLingual} element={<Multilingual />} />
              <Route path={AppRoutes.companyAdmin} element={<CompanyAdmin />} />
              <Route path={AppRoutes.uiConfiguration} element={<UIConfiguration />} />
              <Route path={AppRoutes.moduleManagement} element={<ModuleManagement />} />
              <Route path={AppRoutes.security} element={<Security />} />
            </Route>
          </Route>

          <Route path={AppRoutes.standards} element={<Standards />} />
          <Route path={AppRoutes.standardsIRO} element={<StandardsIRO />} />
          <Route path={AppRoutes.sectorSpecific} element={<SectorSpecific />} />
          <Route path={AppRoutes.agentsManagement} element={<AgentsManagement />} />
          <Route path={AppRoutes.watchTower} element={<WatchTowerRegistry />} />
          <Route path={AppRoutes.watchTowerCompany} element={<WatchTowerCompany />} />
          <Route path={AppRoutes.watchTowerImport} element={<WatchTowerImport />} />
          <Route path={AppRoutes.watchTowerSchedules} element={<WatchTowerSchedules />} />
          <Route path={AppRoutes.watchTowerRuns} element={<WatchTowerRuns />} />
          <Route path={AppRoutes.watchTowerTopics} element={<WatchTowerTopics />} />
          <Route path={AppRoutes.watchTowerTopic} element={<WatchTowerTopic />} />
          <Route path={AppRoutes.marketingOps} element={<MarketingOps />} />
          <Route path={AppRoutes.marketingOpsFinding} element={<MarketingOpsFinding />} />
          <Route
            path={AppRoutes.valueChainMap}
            element={<ValueChainMap />}
            handle={{ skipBreadcrumbs: true }}
          />

          <Route element={<BaseMultilingual />} path={AppRoutes.baseMultilingual} />
          <Route element={<CompanyMap />} path={AppRoutes.companyMap} />

          <Route path={AppRoutes.taskManagement} element={<TaskManagement />} />
          <Route path={AppRoutes.taskManagementId} element={<TaskInfo />} />

          <Route path={AppRoutes.materialityAssessment}>
            <Route path={AppRoutes.materialityAssessment} element={<MaterialityAssessment />} />
            <Route element={<MaterialAssessmentLayout />}>
              <Route path={AppRoutes.materialityAssessmentInitiate} element={<MaterialityAssessmentInitial />} />
              <Route
                path={AppRoutes.materialityAssessmentStakeholders}
                element={<MaterialityAssessmentStakeholder />}
              />
              <Route
                path={AppRoutes.materialityAssessmentTopicIdentification}
                element={<MaterialityAssessmentTopicRefinement />}
              />
              <Route
                path={AppRoutes.materialityAssessmentTopicRefinement}
                element={<MATopicRefinement />}
              />
              <Route
                path={AppRoutes.materialityAssessmentTopicRefinementII}
                element={<MATopicRefinement topicRefinementII />}
              />
              <Route
                path={AppRoutes.materialityAssessmentIRORefinement}
                element={<MATopicRefinement IROIdentification />}
              />
              <Route
                path={AppRoutes.materialityAssessmentSurveyCreation}
                element={<MaterialityAssessmentSurveyCreation />}
              />
              <Route path={AppRoutes.materialityAssessmentSurvey} element={<MaterialityAssessmentSurvey />} />
              <Route path={AppRoutes.materialityAssessmentInterview} element={<MaterialityAssessmentInterview />} />
              <Route path={AppRoutes.materialityAssessmentRoundtables} element={<MaterialAssessmentRoundTables />} />
              <Route
                path={AppRoutes.materialityAssessmentInsightsDashboard}
                element={<MaterialAssessmentInsightsDashboard />}
              />
              <Route
                path={AppRoutes.materialityAssessmentIROIdentification}
                element={<MaterialAssessmentIROIndetificator />}
              />
              <Route
                path={AppRoutes.materialityAssessmentIROScoring}
                element={<MAIroScoring />}
              />

            </Route>
            <Route element={<MaterialAssessmentImportLayout />}>
              <Route path={AppRoutes.materialityAssessmentSupplier} element={<MaterialityAssessmentSupplier />} />
              <Route path={AppRoutes.materialityAssessmentInvestors} element={<MaterialityAssessmentInvestor />} />
              <Route path={AppRoutes.materialityAssessmentBoards} element={<MaterialityAssessmentBoard />} />
              <Route path={AppRoutes.materialityAssessmentEmployees} element={<MaterialityAssessmentEmployees />} />
              <Route path={AppRoutes.materialityAssessmentCustomers} element={<MaterialityAssessmentCustomer />} />
              <Route
                path={AppRoutes.materialityAssessmentLocalCommunity}
                element={<MaterialityAssessmentCommunities />}
              />
              <Route path={AppRoutes.materialityAssessmentLocalMedia} element={<MaterialityAssessmentMedia />} />
              <Route path={AppRoutes.materialityAssessmentLocalNGOs} element={<MaterialityAssessmentNGO />} />
            </Route>
            <Route path={AppRoutes.materialityAssessmentSurveyCreate} element={<CreateSurvey />} />
            <Route path={AppRoutes.materialityAssessmentSurveyEdit} element={<CreateSurvey />} />
          </Route>
          <Route
            path={AppRoutes.materialityAssessmentInvestorsCustomersEvidence}
            element={<MaterialityConfigInvestorsCustomersEvidence />}
          />
          <Route
            path={AppRoutes.materialityAssessmentNonRegulatory}
            element={<MaterialityConfigDisclosure />}
          />
          <Route
            path={AppRoutes.materialityAssessmentCompetitor}
            element={<MaterialityConfigCompetitor />}
          />
          <Route
            path={AppRoutes.materialityAssessmentGeographic}
            element={<MaterialityConfigGeographic />}
          />
          <Route
            path={AppRoutes.materialityAssessmentIndustry}
            element={<MaterialityConfigIndustry />}
          />
          <Route
            path={AppRoutes.materialityAssessmentAnalysis}
            element={<MaterialityConfigAnalysis />}
          />

          <Route
            path={AppRoutes.materialityAssessmentRespondentSurveys}
            element={<MARespondentSurveys />}
          />
        </Route>
      </Route>,
    ),
  );

  return (
    <div>
      <FullScreen handle={fullScreenHandle}>
        <RouterProvider router={router} />
        <ToastContainer
          stacked
          hideProgressBar
          icon={toastIcons}
        />
      </FullScreen>
    </div>
  );
}

export default App;
